export const RARITY_TIERS = ['Common', 'Rare', 'Epic', 'Legendary'];
/**
 * Turn % distribution into per-item tiers.
 * Counts use largest remainder (exact % matching for integer N), then Fisher–Yates
 * so upload/list order is not rarity order.
 */
export function assignRarityTiers(count, distribution) {
    if (count <= 0)
        return [];
    const tiers = Object.keys(distribution);
    if (!tiers.length)
        return Array.from({ length: count }, () => 'Common');
    const exact = tiers.map((tier) => ({
        tier,
        exact: ((Number(distribution[tier]) || 0) / 100) * count,
    }));
    const floors = exact.map(({ tier, exact: e }) => ({
        tier,
        n: Math.floor(e),
        rem: e - Math.floor(e),
    }));
    let remaining = count - floors.reduce((sum, f) => sum + f.n, 0);
    const byRemain = [...floors].sort((a, b) => b.rem - a.rem || a.tier.localeCompare(b.tier));
    for (let i = 0; i < remaining; i += 1) {
        byRemain[i % byRemain.length].n += 1;
    }
    const counts = Object.fromEntries(floors.map((f) => [f.tier, f.n]));
    const bag = [];
    for (const tier of tiers) {
        for (let i = 0; i < (counts[tier] || 0); i += 1)
            bag.push(tier);
    }
    while (bag.length < count)
        bag.push(tiers[0]);
    if (bag.length > count)
        bag.length = count;
    for (let i = bag.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = bag[i];
        bag[i] = bag[j];
        bag[j] = tmp;
    }
    return bag;
}
